// extracted by mini-css-extract-plugin
module.exports = {"root":"Panel_root__3GpWd","active":"Panel_active__1RocU"};